import { render, staticRenderFns } from "./DDDInformation.vue?vue&type=template&id=71d7d91a&"
import script from "./DDDInformation.vue?vue&type=script&lang=js&"
export * from "./DDDInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports